'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.updateAll = updateAll;
exports.update = update;

var _quCheck = require('../utils/qu-check');

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _apiCheck = require('api-check');

var _apiCheck2 = _interopRequireDefault(_apiCheck);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  updateAll: updateAll,
  update: update

  /**
   * Update waypoints on job
   * @param {Object} attrs - Attributes
   * @param {string} [attrs.jobId] - order number associated with the job
   * @param {array} [attrs.sorting] - an array of waypoint ids to sort positioning in job
   * @returns {promise} containing the entity array of waypoints
   */
};
function updateAll() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      others = (0, _objectWithoutProperties3.default)(attrs, ['jobId']);

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);

  return _apiClient2.default.put({ route: '/partner/jobs/' + jobId + '/waypoints', data: (0, _extends3.default)({}, others) });
}

/**
 * Update waypoints on job
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.jobId] - order number associated with the job
 * @returns {Object} containing the time constraint
 */
function update() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      _attrs$waypoint = attrs.waypoint,
      waypoint = _attrs$waypoint === undefined ? {} : _attrs$waypoint;
  var id = waypoint.id,
      waypointAttrs = (0, _objectWithoutProperties3.default)(waypoint, ['id']);

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _apiCheck2.default.number(id);

  return _apiClient2.default.put({ route: '/partner/jobs/' + jobId + '/waypoints/' + id, data: (0, _extends3.default)({}, waypointAttrs) }).then(function (waypointObj) {
    return _modelProvider2.default.Waypoint(waypointObj, { jobId: jobId });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/waypoints.js
// module id = 1081
// module chunks = 0